// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34IYC","rootNoMargin":"styles_rootNoMargin__3tPFj"};